import { useDispatch, useSelector } from "react-redux"

import { carrierTypeOptionById, carrierTypesOptions } from "../../../../lib/systemData"
import { caseActions } from "../../../../store/case"
import { caseQuickUpdate } from "../../../../lib/fetchApi"
import { notificationActions } from "../../../../store/notifications"
import CustomSelectMultiple from "../../../common/interactive/CustomSelectMultiple"

const MajorMedCarrierSelect = ({data}) => {
    const dispatch = useDispatch()

    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase) 

    let carrier_types = carrierTypesOptions()

    const setCarrierTypesHandler = async (value) => {
        let reqBody = {
            type: value.identifier.type,
            type_id: value.identifier.type_id,
            fields: {
                [value.identifier.field] : value.data.value,
            }
        }

        dispatch(caseActions.modifyActiveCase({
            folder: 'major_meds',
            item: {
                itemId: data.id,
                field: value.identifier.field,
                value: value.data.value,
            },
        }))

        let update = await caseQuickUpdate(userToken, activeCase.case.id, reqBody, dispatch)

        if (update && update.errorMessage) {
            dispatch(notificationActions.setError(update))
        } else {            
        }  
        
    }

    return <>
        <CustomSelectMultiple
            label={'Type of Carrier'}
            optionsData={carrier_types}
            preSelectedValue={data.carrier_types}
            action={setCarrierTypesHandler}
            identifier={{type: 'case_major_med', field: 'carrier_types', type_id: data.id}}
            fallbackSelectedOption={carrierTypeOptionById}
        />
    </>
}

export default MajorMedCarrierSelect